var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0 wizard-kalkulacia" },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { autocomplete: "off" },
          model: {
            value: _vm.formValid,
            callback: function($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid"
          }
        },
        [
          !_vm.isMobile
            ? _c(
                "h1",
                { staticClass: "mt-45px mb-28px", on: { click: _vm.log } },
                [_vm._v("Kalkulácia")]
              )
            : _vm._e(),
          _vm.debug
            ? _c("debug-control", {
                attrs: {
                  value: [
                    "validationObjectResult",
                    "formValid",
                    "somethingGetDirty",
                    "somethingIsLoading",
                    "currentControl",
                    "pripad"
                  ],
                  parent: this
                },
                on: { click: _vm.log }
              })
            : _vm._e(),
          _c(
            "v-card",
            { staticClass: "card" },
            [
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isControlVisible(
                        "cbAkontacia",
                        "liw_filip__wiz_kalkulacia__cb_akontacia",
                        true
                      ),
                      expression:
                        "isControlVisible('cbAkontacia','liw_filip__wiz_kalkulacia__cb_akontacia',true)"
                    }
                  ],
                  attrs: { "no-gutters": _vm.isMobile }
                },
                [
                  _c(
                    "v-col",
                    { attrs: { xl: "9", lg: "9", md: "9" } },
                    [
                      _c("akontacia-button-group", {
                        ref: "cbAkontacia",
                        attrs: {
                          dynamic: "",
                          parentReloaded: _vm.reloaded,
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          dataId: "liw_filip__wiz_kalkulacia__cb_akontacia",
                          multiple: "",
                          max: 5,
                          chip: "",
                          mandatory: false,
                          disabled: _vm.isCalculating,
                          showRequired: ""
                        },
                        on: {
                          valueChanged: function($event) {
                            return _vm.akontaciaTenorChanged()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isControlVisible(
                        "txtAkontacia",
                        "liw_filip__wiz_kalkulacia__txt_akontacia_s_dph",
                        true
                      ),
                      expression:
                        "isControlVisible('txtAkontacia','liw_filip__wiz_kalkulacia__txt_akontacia_s_dph',true)"
                    }
                  ],
                  class: { "mt-16px": _vm.isMobile },
                  attrs: { "no-gutters": _vm.isMobile }
                },
                [
                  _c(
                    "v-col",
                    { attrs: { xl: "4", lg: "4", md: "4" } },
                    [
                      _c("numeric-text-box", {
                        ref: "txtAkontacia",
                        attrs: {
                          dynamic: "",
                          parentReloaded: _vm.reloaded,
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          dataId:
                            "liw_filip__wiz_kalkulacia__txt_akontacia_s_dph",
                          suffix: "€",
                          disabled: _vm.isCalculating
                        },
                        on: {
                          valueChanged: function($event) {
                            return _vm.akontaciaTxtChanged()
                          },
                          focus: function($event) {
                            return _vm.akontaciaTxtFocus()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isControlVisible(
                        "cbAkontacia",
                        "liw_filip__wiz_kalkulacia__cb_akontacia",
                        true
                      ),
                      expression:
                        "isControlVisible('cbAkontacia','liw_filip__wiz_kalkulacia__cb_akontacia',true)"
                    }
                  ],
                  class: { "mb-12px": _vm.isMobile },
                  attrs: { "no-gutters": _vm.isMobile }
                },
                [
                  _c(
                    "v-col",
                    { attrs: { xl: "12", lg: "12", md: "12" } },
                    [_c("v-divider")],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { "no-gutters": _vm.isMobile } },
                [
                  _c(
                    "v-col",
                    { attrs: { xl: "9", lg: "9", md: "9" } },
                    [
                      _vm.pripad.jeFlSu
                        ? _c("button-group", {
                            ref: "tenor",
                            attrs: {
                              dynamic: "",
                              parentReloaded: _vm.reloaded,
                              cisloPredmetu: _vm.pripad.cisloPredmetu,
                              dataId: "liw_filip__wiz_kalkulacia__cb_tenor",
                              chip: "",
                              max: 3,
                              multiple: "",
                              mandatory: false,
                              info: "Maximálne 3 možnosti",
                              disabled: _vm.isCalculating,
                              showRequired: "",
                              labelTooltip: ""
                            },
                            on: {
                              valueChanged: function($event) {
                                return _vm.akontaciaTenorChanged()
                              }
                            }
                          })
                        : _c("button-group", {
                            ref: "tenor",
                            attrs: {
                              dynamic: "",
                              parentReloaded: _vm.reloaded,
                              cisloPredmetu: _vm.pripad.cisloPredmetu,
                              dataId: "liw_filip__wiz_kalkulacia__cb_tenor",
                              chip: "",
                              mandatory: false,
                              info: "Vyberte 1 možnosti",
                              disabled: _vm.isCalculating,
                              showRequired: "",
                              labelTooltip: ""
                            },
                            on: {
                              valueChanged: function($event) {
                                return _vm.akontaciaTenorChanged()
                              }
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.pripad.jeOlfs
                ? [
                    _c(
                      "v-row",
                      {
                        staticClass: "pt-12px mb-12px",
                        attrs: { "no-gutters": "" }
                      },
                      [
                        _c(
                          "v-col",
                          { attrs: { xl: "12", lg: "12", md: "12" } },
                          [_c("v-divider")],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        class: { "mt-16px": _vm.isMobile },
                        attrs: { "no-gutters": _vm.isMobile }
                      },
                      [
                        _c(
                          "v-col",
                          { attrs: { xl: "4", lg: "4", md: "4" } },
                          [
                            _c("dynamic-combo", {
                              key: "liw_filip__wiz_kalkulacia__cb_rocny_najazd",
                              ref: "rocny_najazd",
                              attrs: {
                                parentReloaded: _vm.reloaded,
                                dataId:
                                  "liw_filip__wiz_kalkulacia__cb_rocny_najazd",
                                cisloPredmetu: _vm.pripad.cisloPredmetu,
                                disabled: _vm.isCalculating
                              },
                              on: { valueChanged: _vm.onRocnyNajazdChanged }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "pt-12px mb-12px",
                        attrs: { "no-gutters": "" }
                      },
                      [
                        _c(
                          "v-col",
                          { attrs: { xl: "12", lg: "12", md: "12" } },
                          [_c("v-divider")],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.isMobile
                ? _c(
                    "v-row",
                    {
                      staticClass: "pt-12px mb-12px",
                      attrs: { "no-gutters": "" }
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { xl: "12", lg: "12", md: "12" } },
                        [_c("v-divider")],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                {
                  staticClass: "mobile-flex-direction-kalkulacia",
                  attrs: { "no-gutters": _vm.isMobile }
                },
                [
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isControlVisible(
                            "hladinaProvizie",
                            "liw_filip__wiz_kalkulacia__cb_hladina_provizie"
                          ),
                          expression:
                            "isControlVisible('hladinaProvizie','liw_filip__wiz_kalkulacia__cb_hladina_provizie')"
                        }
                      ],
                      attrs: { xl: "4", lg: "4", md: "4", sm: "12" }
                    },
                    [
                      _c("dynamic-combo", {
                        ref: "hladinaProvizie",
                        attrs: {
                          dynamic: "",
                          parentReloaded: _vm.reloaded,
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          dataId:
                            "liw_filip__wiz_kalkulacia__cb_hladina_provizie",
                          clearable: "",
                          disabled: _vm.isCalculating
                        },
                        on: {
                          valueChanged: function($event) {
                            _vm.forceProduktFormsDirty = true
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { xl: "4", lg: "4", md: "4", sm: "12" } },
                    [
                      _c("date-picker", {
                        ref: "datum_podpisu",
                        attrs: {
                          placeholder: "DD/MM/YYYY",
                          dynamic: "",
                          parentReloaded: _vm.reloaded,
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          dataId:
                            "liw_filip__wiz_kalkulacia__txt_datum_podpisu",
                          disabled: _vm.isCalculating,
                          min: _vm.formatDate(new Date()),
                          lastDayInMonth: ""
                        },
                        on: {
                          valueChanged: _vm.onDatumPodpisuValueChanged,
                          dataLoaded: function(val) {
                            return _vm.setMinDatumDodania(val)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { xl: "4", lg: "4", md: "4", sm: "12" } },
                    [
                      _c("date-picker", {
                        ref: "datum_dodania",
                        attrs: {
                          placeholder: "DD/MM/YYYY",
                          dynamic: "",
                          parentReloaded: _vm.reloaded,
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          dataId:
                            "liw_filip__wiz_kalkulacia__txt_datum_dodania",
                          disabled: _vm.isCalculating,
                          min: _vm.formatDate(_vm.minDatumDodania)
                        },
                        on: { valueChanged: _vm.onDatumDodaniaValueChanged }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mobile-flex-direction-kalkulacia" },
                [
                  _c(
                    "v-col",
                    { attrs: { xl: "4", lg: "4", md: "4", sm: "12" } },
                    [
                      _c("button-group", {
                        key: "liw_filip__wiz_kalkulacia_produkt__btn_s_dph",
                        ref: "btn_dph",
                        attrs: {
                          switchBtn: "",
                          small: "",
                          dynamic: "",
                          staticLabel: "Zobrazenie výpočtu",
                          dataId:
                            "liw_filip__wiz_kalkulacia_produkt__btn_s_dph",
                          disabled: _vm.isCalculating,
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          ignoreDirty: true
                        },
                        on: { valueChanged: _vm.btnDphValueChanged },
                        model: {
                          value: _vm.btnDphValue,
                          callback: function($$v) {
                            _vm.btnDphValue = $$v
                          },
                          expression: "btnDphValue"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isControlVisible(
                            "EIB_financovanie",
                            "liw_filip__wiz_kalkulacia__btn_eib_financovanie"
                          ),
                          expression:
                            "isControlVisible('EIB_financovanie','liw_filip__wiz_kalkulacia__btn_eib_financovanie')"
                        }
                      ],
                      staticStyle: { "align-self": "center" },
                      attrs: { xl: "4", lg: "4", md: "4", sm: "12" }
                    },
                    [
                      _c("check-box", {
                        ref: "EIB_financovanie",
                        style: !_vm.isMobile
                          ? { marginTop: "20px" }
                          : { marginTop: "0px !important" },
                        attrs: {
                          label: "EIB financovanie",
                          dataId:
                            "liw_filip__wiz_kalkulacia__btn_eib_financovanie",
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          parentReloaded: _vm.reloaded,
                          disabled: _vm.isCalculating,
                          hideDetails: ""
                        },
                        on: {
                          valueChanged: function($event) {
                            _vm.forceProduktFormsDirty = true
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isControlVisible(
                            "datum_akontacie",
                            "liw_filip__wiz_kalkulacia__txt_datum_akontacie"
                          ),
                          expression:
                            "isControlVisible('datum_akontacie','liw_filip__wiz_kalkulacia__txt_datum_akontacie')"
                        }
                      ],
                      attrs: { xl: "4", lg: "4", md: "4", sm: "12" }
                    },
                    [
                      _c("date-picker", {
                        ref: "datum_akontacie",
                        attrs: {
                          placeholder: "DD/MM/YYYY",
                          dynamic: "",
                          parentReloaded: _vm.reloaded,
                          cisloPredmetu: _vm.pripad.cisloPredmetu,
                          dataId:
                            "liw_filip__wiz_kalkulacia__txt_datum_akontacie",
                          disabled: _vm.isCalculating
                        },
                        on: {
                          valueChanged: function($event) {
                            _vm.forceProduktFormsDirty = true
                          },
                          dataLoaded: function() {
                            return _vm.datumAkontacieLoaded()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "v-card",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visibleProvizie,
                  expression: "visibleProvizie"
                }
              ],
              staticClass: "card",
              class: _vm.isMobile ? "mt-16px" : "mt-30px"
            },
            [
              _c(
                "v-expansion-panels",
                {
                  staticClass: "wizard-expansion-panels",
                  attrs: { accordion: "", flat: "" },
                  model: {
                    value: _vm.showProvizie,
                    callback: function($$v) {
                      _vm.showProvizie = $$v
                    },
                    expression: "showProvizie"
                  }
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c("v-expansion-panel-header", { staticClass: "pa-0" }, [
                        _c("h2", [_vm._v(" Provízie ")])
                      ]),
                      _c(
                        "v-expansion-panel-content",
                        { staticClass: "mt-12px", attrs: { eager: "" } },
                        [
                          _c(
                            "v-row",
                            { staticClass: "mobile-flex-direction-kalkulacia" },
                            [
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isControlVisible(
                                        "btn_prov_dod",
                                        "liw_filip__wiz_kalkulacia__btn_perc_suma_dod",
                                        true
                                      ),
                                      expression:
                                        "isControlVisible('btn_prov_dod','liw_filip__wiz_kalkulacia__btn_perc_suma_dod',true)"
                                    }
                                  ],
                                  attrs: { md: "6", cols: "12" }
                                },
                                [
                                  _c(
                                    "v-row",
                                    [_c("v-col", [_vm._v("Dodávateľ")])],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "align-content-start",
                                          attrs: {
                                            xl: "4",
                                            lg: "4",
                                            md: "4",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("button-group", {
                                            key:
                                              "liw_filip__wiz_kalkulacia__btn_perc_suma_dod",
                                            ref: "btn_prov_dod",
                                            attrs: {
                                              switchBtn: "",
                                              dynamic: "",
                                              dataId:
                                                "liw_filip__wiz_kalkulacia__btn_perc_suma_dod",
                                              reloaded: _vm.reloaded,
                                              disabled: _vm.isCalculating,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.btnProvDodValueChanged
                                            },
                                            model: {
                                              value: _vm.btnProvDodValue,
                                              callback: function($$v) {
                                                _vm.btnProvDodValue = $$v
                                              },
                                              expression: "btnProvDodValue"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "8",
                                            lg: "8",
                                            md: "8",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.btnProvDodValue == 0,
                                                expression:
                                                  "btnProvDodValue == 0"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_dod_perc",
                                            ref: "prov_dod_perc",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_dod_perc",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "%",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.akontaciaTenorValid,
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_dod_perc",
                                                  val
                                                )
                                              }
                                            }
                                          }),
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.btnProvDodValue == 1,
                                                expression:
                                                  "btnProvDodValue == 1"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_dod_suma",
                                            ref: "prov_dod_sum",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_dod_suma",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "€",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.akontaciaTenorValid,
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_dod_sum",
                                                  val
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isControlVisible(
                                        "btn_prov_dod_p",
                                        "liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p",
                                        true
                                      ),
                                      expression:
                                        "isControlVisible('btn_prov_dod_p','liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p',true)"
                                    }
                                  ],
                                  attrs: { md: "6", cols: "12" }
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", [
                                        _vm._v(" Predajca dodávateľa ")
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "align-content-start",
                                          attrs: {
                                            xl: "4",
                                            lg: "4",
                                            md: "4",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("button-group", {
                                            key:
                                              "liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p",
                                            ref: "btn_prov_dod_p",
                                            attrs: {
                                              switchBtn: "",
                                              dynamic: "",
                                              dataId:
                                                "liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p",
                                              reloaded: _vm.reloaded,
                                              disabled: _vm.isCalculating,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.btnProvDodPredajcaValueChanged
                                            },
                                            model: {
                                              value:
                                                _vm.btnProvDodPredajcaValue,
                                              callback: function($$v) {
                                                _vm.btnProvDodPredajcaValue = $$v
                                              },
                                              expression:
                                                "btnProvDodPredajcaValue"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "8",
                                            lg: "8",
                                            md: "8",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.btnProvDodPredajcaValue ==
                                                  0,
                                                expression:
                                                  "btnProvDodPredajcaValue == 0"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_dod_p_perc",
                                            ref: "prov_dod_p_perc",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_dod_p_perc",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "%",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.akontaciaTenorValid,
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_dod_p_perc",
                                                  val
                                                )
                                              }
                                            }
                                          }),
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.btnProvDodPredajcaValue ==
                                                  1,
                                                expression:
                                                  "btnProvDodPredajcaValue == 1"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_dod_p_suma",
                                            ref: "prov_dod_p_sum",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_dod_p_suma",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "€",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.akontaciaTenorValid,
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_dod_p_sum",
                                                  val
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mobile-flex-direction-kalkulacia" },
                            [
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isControlVisible(
                                        "btn_prov_spros",
                                        "liw_filip__wiz_kalkulacia__btn_perc_suma_spros",
                                        true
                                      ),
                                      expression:
                                        "isControlVisible('btn_prov_spros','liw_filip__wiz_kalkulacia__btn_perc_suma_spros',true)"
                                    }
                                  ],
                                  attrs: { md: "6", cols: "12" }
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", [
                                        _vm._v(" Sprostredkovateľ ")
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "mobile-flex-direction-kalkulacia"
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "align-content-start",
                                          attrs: {
                                            xl: "4",
                                            lg: "4",
                                            md: "4",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("button-group", {
                                            key:
                                              "liw_filip__wiz_kalkulacia__btn_perc_suma_spros",
                                            ref: "btn_prov_spros",
                                            attrs: {
                                              switchBtn: "",
                                              dynamic: "",
                                              dataId:
                                                "liw_filip__wiz_kalkulacia__btn_perc_suma_spros",
                                              reloaded: _vm.reloaded,
                                              disabled: _vm.isCalculating,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.btnProvSprosValueChanged
                                            },
                                            model: {
                                              value: _vm.btnProvSprosValue,
                                              callback: function($$v) {
                                                _vm.btnProvSprosValue = $$v
                                              },
                                              expression: "btnProvSprosValue"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "8",
                                            lg: "8",
                                            md: "8",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.btnProvSprosValue == 0,
                                                expression:
                                                  "btnProvSprosValue == 0"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_spros_perc",
                                            ref: "prov_spros_perc",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_spros_perc",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "%",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.akontaciaTenorValid,
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_spros_perc",
                                                  val
                                                )
                                              }
                                            }
                                          }),
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.btnProvSprosValue == 1,
                                                expression:
                                                  "btnProvSprosValue == 1"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_spros_suma",
                                            ref: "prov_spros_sum",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_spros_suma",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "€",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.akontaciaTenorValid,
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_spros_sum",
                                                  val
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isControlVisible(
                                        "btn_prov_spros_p",
                                        "liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p",
                                        true
                                      ),
                                      expression:
                                        "isControlVisible('btn_prov_spros_p','liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p',true)"
                                    }
                                  ],
                                  attrs: { md: "6", cols: "12" }
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", [
                                        _vm._v(" Predajca sprostredkovateľa ")
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "align-content-start",
                                          attrs: {
                                            xl: "4",
                                            lg: "4",
                                            md: "4",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("button-group", {
                                            key:
                                              "liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p",
                                            ref: "btn_prov_spros_p",
                                            attrs: {
                                              switchBtn: "",
                                              dynamic: "",
                                              dataId:
                                                "liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p",
                                              reloaded: _vm.reloaded,
                                              disabled: _vm.isCalculating,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu
                                            },
                                            on: {
                                              valueChanged:
                                                _vm.btnProvSprosPredajcaValueChanged
                                            },
                                            model: {
                                              value:
                                                _vm.btnProvSprosPredajcaValue,
                                              callback: function($$v) {
                                                _vm.btnProvSprosPredajcaValue = $$v
                                              },
                                              expression:
                                                "btnProvSprosPredajcaValue"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "8",
                                            lg: "8",
                                            md: "8",
                                            sm: "12"
                                          }
                                        },
                                        [
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.btnProvSprosPredajcaValue ==
                                                  0,
                                                expression:
                                                  "btnProvSprosPredajcaValue == 0"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_spros_p_perc",
                                            ref: "prov_spros_p_perc",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_spros_p_perc",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "%",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_spros_p_perc",
                                                  val
                                                )
                                              }
                                            }
                                          }),
                                          _c("numeric-text-box", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.btnProvSprosPredajcaValue ==
                                                  1,
                                                expression:
                                                  "btnProvSprosPredajcaValue == 1"
                                              }
                                            ],
                                            key:
                                              "liw_filip__wiz_kalkulacia__txt_prov_spros_p_suma",
                                            ref: "prov_spros_p_sum",
                                            attrs: {
                                              "data-id":
                                                "liw_filip__wiz_kalkulacia__txt_prov_spros_p_suma",
                                              reloaded: _vm.reloaded,
                                              cisloPredmetu:
                                                _vm.pripad.cisloPredmetu,
                                              disabled: _vm.isCalculating,
                                              suffix: "€",
                                              stopMouseDown: "",
                                              emitToParent: ""
                                            },
                                            on: {
                                              validationChanged: function(val) {
                                                return _vm.setProvizieError(
                                                  "prov_spros_p_sum",
                                                  val
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.provizieError
                            ? _c(
                                "v-row",
                                {
                                  staticClass:
                                    "mobile-flex-direction-kalkulacia"
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "negative500 d-flex",
                                      staticStyle: { gap: "6px" }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "error", size: "16" }
                                        },
                                        [_vm._v("mdi-alert-circle")]
                                      ),
                                      _vm._v(
                                        " Bola prekročená maximálna výška zazmluvnenej provízie. "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.produkty, function(item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c("produkt-form", {
                  key: "produktForm_" + index + " " + _vm.produktFormKey,
                  ref: "produktForm_" + index,
                  refInFor: true,
                  attrs: {
                    forceFormDirty: _vm.forceProduktFormsDirty,
                    reloaded: _vm.reloaded,
                    cisloPlz: item.cislo_plz,
                    idProduktu: item.id,
                    jeOlfs: item.jeOlfs,
                    cisloPredmetu: _vm.pripad.cisloPredmetu,
                    nazovProduktu: item.nazov,
                    dph: _vm.btnDphValue === 1 ? false : true,
                    isCalculating: _vm.isCalculating,
                    rules: [_vm.produktRule]
                  },
                  on: {
                    produktFormDirty: _vm.produktFormDirty,
                    onVariantSelected: _vm.onVariantSelected,
                    loadingOverlayChanged:
                      _vm.handleProduktLoadingOverlayChanged,
                    initLoaded: _vm.produktFormLoaded,
                    produktValid: function(val) {
                      return _vm.setProduktValid(index, val)
                    },
                    updateCisloPlz: function(val) {
                      return (item.cislo_plz = val)
                    },
                    loadedVarianty: _vm.loadedVarianty
                  },
                  model: {
                    value: _vm.produktyValid[index],
                    callback: function($$v) {
                      _vm.$set(_vm.produktyValid, index, $$v)
                    },
                    expression: "produktyValid[index]"
                  }
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _c("message-box", {
        attrs: {
          title: _vm.warningMessage.title,
          text: _vm.warningMessage.text,
          action: _vm.warningMessage.action,
          persistent: "",
          yesNo: _vm.warningMessage.yesNo,
          hideCancel: _vm.warningMessage.hideCancel
        },
        model: {
          value: _vm.warningMessage.open,
          callback: function($$v) {
            _vm.$set(_vm.warningMessage, "open", $$v)
          },
          expression: "warningMessage.open"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }